"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const framer_motion_1 = require("framer-motion");
const helpers_1 = require("../lib/helpers");
const animations_1 = require("../lib/config/animations");
function useSwipe({ onSwipeLeft, onDragEnd, swipeConfidenceThreshold = 10000, drag = 'x', containerRef, dragElastic = 1, onSwipeRight, dragConstraints = { left: 0, right: 0 }, onDrag, enabled = true, }) {
    var _a, _b, _c;
    const animation = framer_motion_1.useAnimation();
    const [style, setStyle] = react_1.useState();
    const [offscreen, setOffscreen] = react_1.useState(false);
    const runAnimation = react_1.useCallback((direction, whenOffScreen) => __awaiter(this, void 0, void 0, function* () {
        return animation.start(direction === 'left' ? 'slideRight' : 'slideLeft').then(() => {
            // notify <Swipe/> component to temporarily hide its children.
            setOffscreen(true);
            whenOffScreen();
            // reset the order, this sets up the origin of the transition backwards as we slide back in.
            animation.set(direction === 'left' ? 'slideLeft' : 'slideRight');
            // delay a tick
            setTimeout(() => setOffscreen(false), 0);
            // start going back to the origin of where we were.
            return animation.start('center');
        });
    }), [animation]);
    const swipe = react_1.useCallback((direction, quiet = false) => __awaiter(this, void 0, void 0, function* () {
        var _d, _e, _f;
        const containerHeight = (_f = (_e = (_d = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect()) === null || _e === void 0 ? void 0 : _e.height) !== null && _f !== void 0 ? _f : 500;
        // maintain the height to prevent it appearing wonky
        setStyle({ minHeight: containerHeight });
        try {
            yield runAnimation(direction, () => {
                if (!quiet) {
                    if (direction === 'left' && onSwipeLeft) {
                        onSwipeLeft();
                    }
                    if (direction === 'right' && onSwipeRight) {
                        onSwipeRight();
                    }
                }
            });
        }
        catch (error) {
            console.error(error);
        }
        setStyle(undefined);
    }), [containerRef, onSwipeLeft, onSwipeRight, runAnimation]);
    const onDragEndHandle = react_1.useCallback((event, panInfo) => {
        const { offset, velocity } = panInfo;
        const swipeDirection = helpers_1.getSwipeDirection(helpers_1.getSwipePower(offset.x, velocity.x), swipeConfidenceThreshold);
        swipeDirection && swipe(swipeDirection);
        onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(event, panInfo);
    }, [onDragEnd, swipe, swipeConfidenceThreshold]);
    const dragControls = framer_motion_1.useDragControls();
    const onDragHandle = react_1.useCallback((event, info) => {
        if (!enabled) {
            // @ts-ignore
            dragControls.componentControls.forEach((control) => {
                control.stop(event, info);
            });
            return;
        }
        onDrag === null || onDrag === void 0 ? void 0 : onDrag(event, info);
        // @ts-ignore
    }, [dragControls.componentControls, enabled, onDrag]);
    // used to calculate how far the x should go out in the variant swipe animation
    // percentages dont work since the percent is assumed based upon the original x value
    // which in this case would be 0.
    const containerWidth = (_c = (_b = (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : 500;
    return {
        swipe,
        offscreen,
        props: Object.assign(Object.assign({ custom: containerWidth }, animations_1.getMotionAnimation('j-swipe-anim')), { drag,
            dragConstraints, animate: animation, style,
            dragElastic, dragPropagation: true, dragControls, onDrag: onDragHandle, onDragEnd: onDragEndHandle }),
    };
}
exports.default = useSwipe;
